"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnswerType = exports.VALIDATE_TYPES = void 0;
var _ = require("lodash");
var draft_js_1 = require("draft-js");
var types_1 = require("../types");
var constants_1 = require("../constants");
var VALIDATE_TYPES;
(function (VALIDATE_TYPES) {
    VALIDATE_TYPES["REQUIRED"] = "REQUIRED";
    VALIDATE_TYPES["NOT_UNIQUE"] = "NOT_UNIQUE";
    VALIDATE_TYPES["NOT_VALID"] = "NOT_VALID";
    VALIDATE_TYPES["EMPTY"] = "EMPTY";
    VALIDATE_TYPES["DUPLICATE"] = "DUPLICATE";
})(VALIDATE_TYPES = exports.VALIDATE_TYPES || (exports.VALIDATE_TYPES = {}));
/**
 * Maps the numerical value of ConditionRule operators (key: number) to a type of answer (value: string)
 * such that the validity/eligibility of a particular operator can be checked for a particular answer.
 */
exports.AnswerType = {
    1: 'options',
    2: 'options',
    3: 'number',
    4: 'number',
    5: 'number',
    6: 'string',
    7: 'string',
    8: 'string',
    9: 'string',
    10: 'string',
    11: 'regex',
    12: 'number',
    13: 'number',
    14: 'number',
    15: 'number',
    16: 'boolean',
    17: 'boolean'
};
/**
 * ValidationService provides a suite of validation functions which get mapped to each of the QTYPES,
 * and can be used to validate that any question created on the portal is valid. Each of its methods
 * returns an error message if the question is invalid.
 */
var ValidationService = /** @class */ (function () {
    function ValidationService(type) {
        var _a;
        var _this = this;
        this.questionErrorMessages = {
            REQUIRED: 'This field is required',
            UNIQUE_QUESTION_TITLE: 'Please make sure the question title has a unique title within a project.',
            NOT_VALID: 'This field is not valid',
            EMPTY: 'Please add at least one item',
            EMPTY_MIN_MAX: 'Please add both min and max',
            NUM_OPTIONS: 'The min/max number must be smaller than the amount of options available.',
            MIN_INVALID: 'Min value should not be greater than max value.',
            OPTION_LAYOUT_INVALID: 'Option displayed in a row should be smaller than or equal to total number of the option card added.',
            NUMERIC_UNIT_INVALID: 'Unit should be less than 25 characters'
        };
        this.ERROR_MESSAGES = {
            required: this.questionErrorMessages.REQUIRED,
            title_unique: this.questionErrorMessages.UNIQUE_QUESTION_TITLE,
            invalid: this.questionErrorMessages.NOT_VALID,
            duplicate: this.questionErrorMessages.NOT_VALID,
            empty: this.questionErrorMessages.EMPTY,
            empty_min_max: this.questionErrorMessages.EMPTY_MIN_MAX,
            num_options: this.questionErrorMessages.NUM_OPTIONS,
            min_invalid: this.questionErrorMessages.MIN_INVALID,
            option_layout_invalid: this.questionErrorMessages.OPTION_LAYOUT_INVALID,
            numeric_unit_invalid: this.questionErrorMessages.NUMERIC_UNIT_INVALID
        };
        this.ERROR_TYPES = {
            required: VALIDATE_TYPES.REQUIRED,
            title_unique: VALIDATE_TYPES.NOT_UNIQUE,
            invalid: VALIDATE_TYPES.NOT_VALID,
            duplicate: VALIDATE_TYPES.DUPLICATE,
            empty: VALIDATE_TYPES.EMPTY,
            empty_min_max: VALIDATE_TYPES.EMPTY,
            num_options: VALIDATE_TYPES.NOT_VALID,
            min_invalid: VALIDATE_TYPES.NOT_VALID,
            option_layout_invalid: VALIDATE_TYPES.NOT_VALID,
            numeric_unit_invalid: VALIDATE_TYPES.NOT_VALID
        };
        /** BEGIN QUESTION VALIDATION */
        this.skipQuestionValidation = function (question, isError, errorObject, languages, questionTitles) {
            return { errorObject: errorObject, isError: isError };
        };
        this.validateMultimedia = function (question, isError, errorObject, languages, questionTitles) {
            var _a;
            var mediaURL = question.mediaURL, showImage = question.showImage, showText = question.showText, playVideo = question.playVideo, videoURL = question.videoURL, embeddedURL = question.embeddedURL;
            if (showImage) {
                if (_this.isEmpty(mediaURL)) {
                    isError = true;
                    errorObject = __assign(__assign({}, errorObject), { mediaURL: _this.getErrorMessage('required') });
                }
            }
            if (!showText) {
                isError = false;
                errorObject = __assign(__assign({}, errorObject), { questionTexts: {} });
            }
            if (playVideo &&
                _this.isEmpty(videoURL) &&
                _this.isEmpty(embeddedURL)) {
                isError = true;
                errorObject = __assign(__assign({}, errorObject), { videoURL: _this.getErrorMessage('required') });
            }
            var isMedia = question.showImage || question.playVideo || false;
            if (!question.showText && !isMedia) {
                isError = true;
            }
            if ((_a = question === null || question === void 0 ? void 0 : question.multimediaSettings) === null || _a === void 0 ? void 0 : _a.showEmbeddedURL) {
                if (_this.isEmpty(question.embeddedURL)) {
                    isError = true;
                    errorObject = __assign(__assign({}, errorObject), { embeddedURL: _this.getErrorMessage('required') });
                }
                if (!constants_1.URL_VALIDATE_REGEX.test(question.embeddedURL)) {
                    isError = true;
                    errorObject = __assign(__assign({}, errorObject), { embeddedURL: _this.getErrorMessage('invalid') });
                }
            }
            return { errorObject: errorObject, isError: isError };
        };
        this.validateDepartingMessage = function (question, isError, errorObject, languages, questionTitles) {
            var completed = question.completed, url = question.url;
            if (_this.isEmpty(completed)) {
                isError = true;
                errorObject = __assign(__assign({}, errorObject), { completed: _this.getErrorMessage('required') });
            }
            if (!constants_1.URL_VALIDATE_REGEX.test(url)) {
                isError = true;
                errorObject = __assign(__assign({}, errorObject), { url: _this.getErrorMessage('invalid') });
            }
            if (_this.isEmpty(url)) {
                isError = true;
                errorObject = __assign(__assign({}, errorObject), { url: _this.getErrorMessage('required') });
            }
            return { errorObject: errorObject, isError: isError };
        };
        this.validateIconScale = function (question, isError, errorObject, languages, questionTitles) {
            var iconType = question.iconType, iconNumber = question.iconNumber;
            if (_this.isEmpty(iconType)) {
                isError = true;
                errorObject.iconType = _this.getErrorMessage('required');
            }
            if (_this.isEmpty(iconNumber)) {
                isError = true;
                errorObject.iconNumber = _this.getErrorMessage('required');
            }
            return { errorObject: errorObject, isError: isError };
        };
        this.validateOpenEnd = function (question, isError, errorObject, languages, questionTitles) {
            var showValidation = question.showValidation, validationType = question.validationType;
            if (showValidation) {
                if (_this.isEmpty(validationType)) {
                    isError = true;
                    errorObject = __assign(__assign({}, errorObject), { validationType: _this.getErrorMessage('required') });
                }
            }
            // if (question.showTopics) {
            //     const valueObject: any = {};
            //     (question.topics || []).forEach((topic) => {
            //         if (valueObject[topic.value]) {
            //             valueObject[topic.value]++;
            //         } else {
            //             valueObject[topic.value] = 1;
            //         }
            //     });
            //     if ((question.topics || []).length === 0) {
            //         if (!state.isTopicAdd) {
            //             isError = true;
            //             errorObject.emptyTopics = questionErrorMessage.TOPIC_MINIMUM;
            //         }
            //     } else {
            //         const topics = checkTopics(
            //             languages,
            //             question.topics || [],
            //             valueObject
            //         );
            //         if (topics.isError) {
            //             isError = true;
            //             errorObject.topics = topics;
            //         }
            //     }
            //     if (state.isTopicAdd) {
            //         const addTopic = checkTopic(
            //             languages,
            //             state.addTopic,
            //             valueObject,
            //             true
            //         );
            //         if (addTopic.isError) {
            //             isError = true;
            //             errorObject.addTopic = addTopic;
            //         }
            //     }
            // }
            // if (question.showGenericProbe) {
            //     const checkGenericProbe = checkTextWithLanguage(
            //         question,
            //         'genericProbeTexts',
            //         languages,
            //         'showGenericProbe'
            //     );
            //     if (checkGenericProbe.isError) {
            //         isError = true;
            //         errorObject.genericProbe = checkGenericProbe;
            //     }
            // }
            return { errorObject: errorObject, isError: isError };
        };
        this.validateOptions = function (question, isError, errorObject, languages, questionTitles) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            errorObject = __assign(__assign({}, errorObject), { options: {}, optionCard: '', mediaURL: '' });
            if ([types_1.QTYPES.RAPID_CHOICE].includes(question.type) &&
                _this.isEmpty(question === null || question === void 0 ? void 0 : question.mediaURL)) {
                isError = true;
                errorObject.mediaURL = _this.getErrorMessage('required');
            }
            var optionError;
            var adjustOptionNum = ((_a = question === null || question === void 0 ? void 0 : question.optionSettings) === null || _a === void 0 ? void 0 : _a.showOther)
                ? ((_b = question.options) === null || _b === void 0 ? void 0 : _b.length) + 1
                : (_c = question.options) === null || _c === void 0 ? void 0 : _c.length;
            if ([types_1.QTYPES.HOTSPOT, types_1.QTYPES.TREEMAN].includes(question.type)) {
                optionError = _this.checkOptionLabel(question, 'options');
            }
            else {
                optionError = _this.checkOptionWithLanguage(question, 'options', languages, {
                    isRichText: question.isRichText || false
                });
            }
            if (optionError.isError) {
                isError = true;
                errorObject.options = optionError;
            }
            if (!question.piping) {
                if (!((_d = question.options) === null || _d === void 0 ? void 0 : _d.length)) {
                    isError = true;
                    errorObject = __assign(__assign({}, errorObject), { options: __assign(__assign({}, errorObject.options), { isEmptyOptions: _this.getErrorMessage('empty') }) });
                }
                if (question.type === types_1.QTYPES.HOTSPOT &&
                    (!question.min || !question.max)) {
                    isError = true;
                    errorObject.optionCard = _this.getErrorMessage('empty_min_max');
                }
                // if (
                //     [
                //         QTYPES.MULTIPLE_CHOICE,
                //         QTYPES.RANK_ORDER,
                //         QTYPES.HOTSPOT
                //     ].includes(question.type) &&
                //     question.min > question.options.length
                // ) {
                //     isError = true;
                //     errorObject.optionCard = VALIDATE_TYPES.NOT_VALID;
                // }
                if ([
                    types_1.QTYPES.MULTIPLE_CHOICE,
                    types_1.QTYPES.RANK_ORDER,
                    types_1.QTYPES.HOTSPOT
                ].includes(question.type) &&
                    question.min > adjustOptionNum) {
                    isError = true;
                    errorObject.optionCard = _this.getErrorMessage('num_options');
                }
                if ([
                    types_1.QTYPES.MULTIPLE_CHOICE,
                    types_1.QTYPES.RANK_ORDER,
                    types_1.QTYPES.HOTSPOT
                ].includes(question.type) &&
                    question.min > question.max) {
                    isError = true;
                    errorObject.optionCard = _this.getErrorMessage('min_invalid');
                }
                if (question.type === types_1.QTYPES.TRADE_OFF &&
                    question.max < adjustOptionNum) {
                    isError = true;
                    errorObject.optionCard = _this.getErrorMessage('num_options');
                }
                if (question.type === types_1.QTYPES.TRADE_OFF &&
                    question.min > adjustOptionNum) {
                    isError = true;
                    errorObject.optionCard = _this.getErrorMessage('num_options');
                }
                if (Number((_e = question.optionSettings) === null || _e === void 0 ? void 0 : _e.numColumns) > adjustOptionNum) {
                    isError = true;
                    errorObject.optionCard = _this.getErrorMessage('option_layout_invalid');
                }
                if ((_f = question === null || question === void 0 ? void 0 : question.optionSettings) === null || _f === void 0 ? void 0 : _f.showOther) {
                    var checkOtherTexts = _this.validateMultimediaTexts((_h = (_g = question === null || question === void 0 ? void 0 : question.optionSettings) === null || _g === void 0 ? void 0 : _g.otherOption) === null || _h === void 0 ? void 0 : _h.texts, languages, false);
                    if (checkOtherTexts.isError) {
                        isError = true;
                        errorObject = __assign(__assign({}, errorObject), { options: __assign(__assign({}, errorObject.options), { isError: true }) });
                        errorObject.otherTexts = checkOtherTexts;
                    }
                    if ([
                        types_1.OPTION_TYPES.IMAGE_AND_TEXT,
                        types_1.OPTION_TYPES.IMAGE_ONLY
                    ].includes(question === null || question === void 0 ? void 0 : question.selectedOptionType) &&
                        !((_k = (_j = question === null || question === void 0 ? void 0 : question.optionSettings) === null || _j === void 0 ? void 0 : _j.otherOption) === null || _k === void 0 ? void 0 : _k.mediaURL)) {
                        isError = true;
                        errorObject.otherTexts = __assign(__assign({}, errorObject.otherTexts), { mediaURL: _this.getErrorMessage('required') });
                    }
                }
            }
            return {
                isError: isError,
                errorObject: errorObject
            };
        };
        this.validatePopup = function (question, isError, errorObject, languages, questionTitles) {
            var optionValidator = _this.validateOptions(question, isError, errorObject, languages, questionTitles);
            errorObject = optionValidator.errorObject;
            isError = optionValidator.isError;
            var setupQuestion = question.setupQuestion, popupCards = question.popupCards;
            /** BEGIN SETUP QUESTION VALIDATION  */
            if (_this.isEmpty(setupQuestion === null || setupQuestion === void 0 ? void 0 : setupQuestion.title)) {
                isError = true;
                errorObject = __assign(__assign({}, errorObject), { setupQuestion: __assign(__assign({}, errorObject === null || errorObject === void 0 ? void 0 : errorObject.setupQuestion), { title: _this.getErrorMessage('required') }) });
            }
            if ((setupQuestion === null || setupQuestion === void 0 ? void 0 : setupQuestion.title) &&
                !_this.validateQuestionTitle(setupQuestion.title, __spreadArray(__spreadArray([], questionTitles, true), popupCards === null || popupCards === void 0 ? void 0 : popupCards.map(function (card) { var _a; return (_a = card === null || card === void 0 ? void 0 : card.title) === null || _a === void 0 ? void 0 : _a.toLowerCase(); }), true))) {
                isError = true;
                errorObject = __assign(__assign({}, errorObject), { setupQuestion: __assign(__assign({}, errorObject === null || errorObject === void 0 ? void 0 : errorObject.setupQuestion), { title: _this.getErrorMessage('title_unique') }) });
            }
            var checkSetupQuestionTexts = _this.validateMultimediaTexts(setupQuestion === null || setupQuestion === void 0 ? void 0 : setupQuestion.questionTexts, languages);
            if (checkSetupQuestionTexts.isError) {
                isError = true;
                errorObject = __assign(__assign({}, errorObject), { setupQuestion: __assign(__assign({}, errorObject === null || errorObject === void 0 ? void 0 : errorObject.setupQuestion), { questionTexts: checkSetupQuestionTexts }) });
            }
            /** END SETUP QUESTION VALIDATION  */
            var cardValidator = _this.checkPopupcardWithLanguage(question, languages, questionTitles);
            if (cardValidator.isError) {
                isError = true;
                errorObject = __assign(__assign({}, errorObject), { popupCards: __assign(__assign({}, errorObject === null || errorObject === void 0 ? void 0 : errorObject.popupCards), cardValidator.errorObject) });
            }
            return { isError: isError, errorObject: errorObject };
        };
        this.validateGroup = function (question, isError, errorObject, languages, questionTitles) {
            var _a;
            var id = question.id, pickNumber = question.pickNumber, childrenIds = question.childrenIds, groupType = question.groupType;
            if (id && groupType === 'picksomefromgroup') {
                if (_this.isEmpty(pickNumber)) {
                    isError = true;
                    errorObject = __assign(__assign({}, errorObject), { pickNumber: _this.getErrorMessage('required') });
                }
                if (pickNumber < 1 ||
                    pickNumber > ((_a = (childrenIds || [])) === null || _a === void 0 ? void 0 : _a.length)) {
                    isError = true;
                    errorObject = __assign(__assign({}, errorObject), { pickNumber: _this.getErrorMessage('invalid') });
                }
            }
            if (_this.isEmpty(groupType)) {
                isError = true;
                errorObject = __assign(__assign({}, errorObject), { groupType: _this.getErrorMessage('required') });
            }
            return { isError: isError, errorObject: errorObject };
        };
        this.validateVirtualQuestion = function (question, isError, errorObject, languages, questionTitles) {
            var optionValidator = _this.validateOptions(question, isError, errorObject, languages, questionTitles);
            errorObject = optionValidator.errorObject;
            isError = optionValidator.isError;
            var options = question.options;
            options === null || options === void 0 ? void 0 : options.forEach(function (opt, i) {
                var _a;
                var _b;
                if ((_b = opt === null || opt === void 0 ? void 0 : opt.conditions) === null || _b === void 0 ? void 0 : _b.length) {
                    var conditionError = _this.validateAllConditions(types_1.CONDITION_TYPES.PRECONDITION, opt.conditions);
                    if (conditionError.isError) {
                        isError = conditionError.isError;
                        errorObject = __assign(__assign({}, errorObject), { conditions: (_a = {},
                                _a[i] = conditionError,
                                _a.isError = conditionError.isError,
                                _a) });
                    }
                }
            });
            return { isError: isError, errorObject: errorObject };
        };
        this.validateTradeOff = function (question, isError, errorObject, languages, questionTitles) {
            var tradeOffWordingTexts = _this.validateMultimediaTexts(question === null || question === void 0 ? void 0 : question.alternateWordingTexts, languages, !question.showAlternateWording);
            if (tradeOffWordingTexts.isError) {
                isError = true;
                errorObject.alternateWordingTexts = tradeOffWordingTexts;
            }
            var optionValidator = _this.validateOptions(question, isError, errorObject, languages, questionTitles);
            errorObject = optionValidator.errorObject;
            isError = optionValidator.isError;
            var btnValidation = _this.checkButtonWithLanguage(question, 'buttons', languages, false, types_1.OPTION_TYPES.IMAGE_AND_TEXT);
            if (btnValidation.isError) {
                isError = true;
                errorObject.buttons = btnValidation;
            }
            if (question.showFollowUp) {
                var checkFollowUpLike = _this.validateMultimediaTexts(question === null || question === void 0 ? void 0 : question.followUpTextsLike, languages);
                if (checkFollowUpLike.isError) {
                    isError = true;
                    errorObject.followUpTextsLike = checkFollowUpLike;
                }
                var checkFollowUpDislike = _this.validateMultimediaTexts(question === null || question === void 0 ? void 0 : question.followUpTextsDislike, languages);
                if (checkFollowUpDislike.isError) {
                    isError = true;
                    errorObject.followUpTextsDislike = checkFollowUpDislike;
                }
            }
            return { isError: isError, errorObject: errorObject };
        };
        this.validateVideoAnnotation = function (question, isError, errorObject, languages, questionTitles) {
            errorObject = __assign(__assign({}, errorObject), { videoURL: '', min: '' });
            if (question.playVideo &&
                _this.isEmpty(question === null || question === void 0 ? void 0 : question.videoURL) &&
                _this.isEmpty(question === null || question === void 0 ? void 0 : question.embeddedURL)) {
                isError = true;
                errorObject.videoURL = _this.getErrorMessage('required');
            }
            if (!question.min) {
                isError = true;
                errorObject.min = _this.getErrorMessage('required');
            }
            return { isError: isError, errorObject: errorObject };
        };
        this.validateHotspot = function (question, isError, errorObject, languages, questionTitles) {
            var _a;
            errorObject = __assign(__assign({}, errorObject), { buttons: '', followUpTextsLike: '', followUpTextsDislike: '', followUpTextsConfused: '', options: {} });
            if (!((_a = question.buttons) === null || _a === void 0 ? void 0 : _a.length)) {
                isError = true;
                errorObject.buttons = {
                    emptyButtons: _this.getErrorMessage('empty'),
                    isError: true
                };
            }
            var btnValidation = _this.checkButtonWithLanguage(question, 'buttons', languages, false, types_1.OPTION_TYPES.TEXT_ONLY);
            if (btnValidation.isError) {
                isError = true;
                errorObject.buttons = btnValidation;
            }
            var optionValidation = _this.validateOptions(question, isError, errorObject, languages, questionTitles);
            isError = optionValidation.isError;
            errorObject = optionValidation.errorObject;
            if (question.showFollowUp && question.type !== types_1.QTYPES.HOTSPOT) {
                var checkFollowUps = _this.checkFollowUpByEnabledButton(question, languages);
                if (checkFollowUps.isError) {
                    isError = true;
                    errorObject = __assign(__assign({}, errorObject), checkFollowUps);
                }
            }
            return { isError: isError, errorObject: errorObject };
        };
        this.validateTextHighlighter = function (question, isError, errorObject, languages, questionTitles) {
            var _a;
            errorObject = __assign(__assign({}, errorObject), { buttons: '', alternateWordingTexts: '', min: '', max: '', options: {} });
            if (!((_a = question.buttons) === null || _a === void 0 ? void 0 : _a.length)) {
                isError = true;
                errorObject.buttons = {
                    emptyButtons: _this.getErrorMessage('empty'),
                    isError: true
                };
            }
            var btnValidation = _this.checkButtonWithLanguage(question, 'buttons', languages, false, types_1.OPTION_TYPES.TEXT_ONLY);
            if (btnValidation.isError) {
                isError = true;
                errorObject.buttons = btnValidation;
            }
            if (question.showAlternateWording) {
                var checkAlternateWording = _this.validateMultimediaTexts(question === null || question === void 0 ? void 0 : question.alternateWordingTexts, languages, !question.showAlternateWording);
                if (checkAlternateWording.isError) {
                    isError = true;
                    errorObject.alternateWordingTexts = checkAlternateWording;
                }
            }
            if (question.min && question.max && question.min > question.max) {
                isError = true;
                errorObject.max = _this.getErrorMessage('invalid');
            }
            return { isError: isError, errorObject: errorObject };
        };
        this.validateGuidedFantasy = function (question, isError, errorObject, languages, questionTitles) {
            errorObject = __assign(__assign({}, errorObject), { mediaURL: '', alternateWordingTexts: '', max: '' });
            if (question.showAlternateWording) {
                var checkAlternateWording = _this.validateMultimediaTexts(question === null || question === void 0 ? void 0 : question.alternateWordingTexts, languages, !question.showAlternateWording);
                if (checkAlternateWording.isError) {
                    isError = true;
                    errorObject.alternateWordingTexts = checkAlternateWording;
                }
            }
            if (!question.mediaURL) {
                isError = true;
                errorObject.mediaURL = _this.getErrorMessage('required');
            }
            if (!question.max) {
                isError = true;
                errorObject.max = _this.getErrorMessage('required');
            }
            return { isError: isError, errorObject: errorObject };
        };
        this.validateNPSQuestion = function (question, isError, errorObject, languages, questionTitles) {
            var checkFollowUpLike = _this.validateMultimediaTexts(question === null || question === void 0 ? void 0 : question.followUpTextsLike, languages);
            if (checkFollowUpLike.isError) {
                isError = true;
                errorObject.followUpTextsLike = checkFollowUpLike;
            }
            var checkFollowUpDislike = _this.validateMultimediaTexts(question === null || question === void 0 ? void 0 : question.followUpTextsDislike, languages);
            if (checkFollowUpDislike.isError) {
                isError = true;
                errorObject.followUpTextsDislike = checkFollowUpDislike;
            }
            return { isError: isError, errorObject: errorObject };
        };
        /**
         * Special validation for numeric question form
         */
        this.validateNumericQuestion = function (question, isError, errorObject, languages) {
            var _a, _b;
            var openEndedSettings = question.openEndedSettings;
            // Left unit validation - The left unit should be less than 25 characters
            if (((_a = openEndedSettings === null || openEndedSettings === void 0 ? void 0 : openEndedSettings.leftUnit) === null || _a === void 0 ? void 0 : _a.length) > 25) {
                isError = true;
                errorObject.leftUnit = _this.getErrorMessage('numeric_unit_invalid');
            }
            // Right unit validation - The right unit should be less than 25 characters
            if (((_b = openEndedSettings === null || openEndedSettings === void 0 ? void 0 : openEndedSettings.rightUnit) === null || _b === void 0 ? void 0 : _b.length) > 25) {
                isError = true;
                errorObject.rightUnit = _this.getErrorMessage('numeric_unit_invalid');
            }
            // allowDecimal is enabled but numDecimals value is empty
            if ((openEndedSettings === null || openEndedSettings === void 0 ? void 0 : openEndedSettings.allowDecimal) &&
                !(openEndedSettings === null || openEndedSettings === void 0 ? void 0 : openEndedSettings.numDecimals)) {
                isError = true;
                errorObject.numDecimals = _this.getErrorMessage('required');
            }
            // the showMax option is enabled but max value is empty
            if ((openEndedSettings === null || openEndedSettings === void 0 ? void 0 : openEndedSettings.showMax) && _this.isEmpty(question.max)) {
                isError = true;
                errorObject.max = _this.getErrorMessage('required');
            }
            // the showMin option is enabled but min value is empty
            if ((openEndedSettings === null || openEndedSettings === void 0 ? void 0 : openEndedSettings.showMin) && _this.isEmpty(question.min)) {
                isError = true;
                errorObject.min = _this.getErrorMessage('required');
            }
            // when both showMax and showMin are enabled but the min value is greater than the max value
            if ((openEndedSettings === null || openEndedSettings === void 0 ? void 0 : openEndedSettings.showMax) &&
                (openEndedSettings === null || openEndedSettings === void 0 ? void 0 : openEndedSettings.showMin) &&
                question.min > question.max) {
                isError = true;
                errorObject.min = _this.getErrorMessage('min_invalid');
            }
            return { isError: isError, errorObject: errorObject };
        };
        /** END QUESTION VALIDATION  */
        /** BEGIN FIELDS VALIDATION */
        this.validateQuestionTitle = function (title, questionTitles) {
            if (questionTitles === void 0) { questionTitles = []; }
            if (questionTitles === null || questionTitles === void 0 ? void 0 : questionTitles.includes(title === null || title === void 0 ? void 0 : title.toLowerCase())) {
                return false;
            }
            else {
                return true;
            }
        };
        this.isEmpty = function (text, allowSpace) {
            if (allowSpace === void 0) { allowSpace = false; }
            if (typeof text === 'number') {
                if (Number.isNaN(text)) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else if (typeof text === 'string') {
                var trimmedText = text.toString();
                if (!allowSpace) {
                    trimmedText = trimmedText.trim();
                }
                return !trimmedText;
            }
            return !text || false;
        };
        this.isEmptyArray = function (array) {
            if (array === undefined || array.length == 0) {
                return true;
            }
            else {
                return false;
            }
        };
        this.validateUrl = function (url) {
            if (_this.isEmpty(url)) {
                return { isError: true, message: _this.getErrorMessage('required') };
            }
            if (!constants_1.URL_VALIDATE_REGEX.test(url)) {
                return { isError: true, message: _this.getErrorMessage('invalid') };
            }
            return { isError: false };
        };
        this.containsSpecialCharacters = function (text) {
            return !Boolean(text.match(/^[a-zA-Z0-9_-]*$/));
        };
        this.validateGreetingTexts = function (greetingTexts, languages) {
            if (!greetingTexts || !Array.isArray(greetingTexts)) {
                return { isError: true };
            }
            var isGreetingValid = _this.validateMultimediaTexts(greetingTexts, languages);
            return isGreetingValid;
        };
        this.validateRedirectMessage = function (redirectSettings, languages) {
            var _a;
            var errorObject = { isError: false };
            (_a = redirectSettings === null || redirectSettings === void 0 ? void 0 : redirectSettings.redirects) === null || _a === void 0 ? void 0 : _a.forEach(function (redirect) {
                var _a;
                var type = redirect.type, multimediaTexts = redirect.multimediaTexts;
                var redirectValidation = _this.validateMultimediaTexts(multimediaTexts, languages);
                errorObject = __assign(__assign({}, errorObject), (_a = { isError: (errorObject.isError ||
                            redirectValidation.isError) }, _a[type] = redirectValidation, _a));
            });
            return errorObject;
        };
        this.validatePanelSources = function (panels) {
            var isError = false, errorObject = {};
            var panelNames = __spreadArray([], panels.map(function (p) { return p.name; }), true);
            var panelKeys = __spreadArray(__spreadArray([], panels.map(function (p) { return _.snakeCase(p.name).toUpperCase(); }), true), [
                'INCA'
            ], false);
            panels.forEach(function (panel, index) {
                var _a;
                var panelSourceValidation = _this.validatePanelSource(panel, panelNames.filter(function (p, i) { return i !== index; }), // filter out the current panel names
                panelKeys.filter(function (p, i) { return i !== index; }) // filter out the current panel keys
                );
                isError = isError || panelSourceValidation.isError;
                errorObject = __assign(__assign({}, errorObject), (_a = {}, _a[index] = panelSourceValidation, _a));
            });
            return __assign({ isError: isError }, errorObject);
        };
        this.validatePanelSource = function (panel, panelNames, panelKeys) {
            var _a;
            var _b;
            var isError = false, errorObject = {
                name: '',
                identifierKeys: {},
                redirectUrlSettings: (_a = {},
                    _a[types_1.QUOTA_STATUS.COMPLETE] = {
                        url: ''
                    },
                    _a[types_1.QUOTA_STATUS.TERMINATE] = {
                        url: ''
                    },
                    _a[types_1.QUOTA_STATUS.QUOTA_FULL] = {
                        url: ''
                    },
                    _a[types_1.QUOTA_STATUS.SECURITY] = {
                        url: ''
                    },
                    _a)
            };
            if (_this.isEmpty(panel.name)) {
                isError = true;
                errorObject.name = _this.getErrorMessage('required');
            }
            if (panelNames.includes(panel.name)) {
                isError = true;
                errorObject.name = _this.getErrorMessage('required');
            }
            if (panelNames.includes(panel.key)) {
                isError = true;
                errorObject.name = _this.getErrorMessage('invalid');
            }
            (_b = panel.identifierKeys) === null || _b === void 0 ? void 0 : _b.forEach(function (panelIdentifier, index) {
                if (_this.isEmpty(panelIdentifier.identifierParamKey)) {
                    isError = true;
                    errorObject.identifierKeys[index] = {
                        identifierParamKey: _this.getErrorMessage('required')
                    };
                }
            });
            if (panel.enableRedirect) {
                [
                    types_1.QUOTA_STATUS.COMPLETE,
                    types_1.QUOTA_STATUS.TERMINATE,
                    types_1.QUOTA_STATUS.QUOTA_FULL
                ].forEach(function (status) {
                    var _a, _b;
                    var redirectUrlValidation = _this.validateUrl((_b = (_a = panel === null || panel === void 0 ? void 0 : panel.redirectUrlSettings) === null || _a === void 0 ? void 0 : _a[status]) === null || _b === void 0 ? void 0 : _b.url);
                    if (redirectUrlValidation.isError) {
                        isError = true;
                        errorObject.redirectUrlSettings[status].url =
                            redirectUrlValidation.message;
                    }
                });
            }
            return __assign({ isError: isError }, errorObject);
        };
        this.validateMultimediaTexts = function (multimediaTexts, languages, skip, allowSpace) {
            if (skip === void 0) { skip = false; }
            if (allowSpace === void 0) { allowSpace = false; }
            var isError = false;
            var errorObject = {};
            try {
                if (skip) {
                    return { isError: isError };
                }
                languages === null || languages === void 0 ? void 0 : languages.forEach(function (language) {
                    var _a;
                    var multimediaText = multimediaTexts === null || multimediaTexts === void 0 ? void 0 : multimediaTexts.find(function (multimediaText) {
                        return multimediaText.language == language.value;
                    });
                    if (multimediaText) {
                        (_a = multimediaText === null || multimediaText === void 0 ? void 0 : multimediaText.contents) === null || _a === void 0 ? void 0 : _a.forEach(function (content) {
                            var text = '';
                            switch (content.type) {
                                case types_1.MULTIMEDIA_TYPES.RICH_TEXT:
                                    var editorState = draft_js_1.EditorState.createWithContent((0, draft_js_1.convertFromRaw)(content.richText));
                                    text = editorState
                                        .getCurrentContent()
                                        .getPlainText();
                                    break;
                                case types_1.MULTIMEDIA_TYPES.TEXT:
                                    text = content.text;
                                    break;
                                case types_1.MULTIMEDIA_TYPES.AUDIO:
                                case types_1.MULTIMEDIA_TYPES.IMAGE:
                                case types_1.MULTIMEDIA_TYPES.VIDEO:
                                    text = 'skip';
                                    break;
                            }
                            if (_this.isEmpty(text, allowSpace)) {
                                errorObject[language.value] =
                                    _this.getErrorMessage('required');
                                isError = true;
                            }
                        });
                    }
                    else {
                        errorObject[language.value] =
                            _this.getErrorMessage('required');
                        isError = true;
                    }
                });
                return __assign(__assign({}, errorObject), { isError: isError });
            }
            catch (err) {
                console.error(err);
                return { isError: isError };
            }
        };
        this.checkOptionLabel = function (question, keyName) {
            var options = question[keyName] || [];
            var errors = { isError: false };
            var allError = false;
            options.forEach(function (option, index) {
                var isError = false;
                errors[index] = {
                    value: '',
                    label: '',
                    randomizeOption: ''
                };
                if (_this.isEmpty(option.label, true)) {
                    errors[index].label = _this.getErrorMessage('required');
                    isError = true;
                }
                if (_this.isEmpty(option.value)) {
                    errors[index].value = _this.getErrorMessage('required');
                    isError = true;
                }
                if (isError) {
                    allError = true;
                }
            });
            return __assign(__assign({}, errors), { isError: allError });
        };
        this.checkOptionWithLanguage = function (question, keyName, languages, optionsSettings) {
            var options = question[keyName] || [];
            var errors = { isError: false };
            //
            var optionType = question.selectedOptionType; //"imageOnly"; // "textOnly" || "imageOnly" || "imageAndText";
            var isRichTextEditor = optionsSettings.isRichText || false;
            var allError = false;
            var valueNumber = {};
            options === null || options === void 0 ? void 0 : options.forEach(function (option) {
                if (option.value in valueNumber) {
                    valueNumber[option.value]++;
                }
                else {
                    valueNumber[option.value] = 1;
                }
            });
            options.forEach(function (option, index) {
                var isError = false;
                var textsError = {};
                if (optionType !== types_1.OPTION_TYPES.IMAGE_ONLY) {
                    textsError = _this.validateMultimediaTexts(option.texts || [], languages, false, true);
                    if (textsError.isError) {
                        isError = true;
                    }
                }
                errors[index] = {
                    texts: textsError || {},
                    mediaURL: '',
                    altTexts: {},
                    tags: '',
                    value: '',
                    label: '',
                    randomizeOption: ''
                };
                if (optionType === types_1.OPTION_TYPES.IMAGE_AND_TEXT ||
                    optionType === types_1.OPTION_TYPES.IMAGE_ONLY) {
                    if (_this.isEmpty(option.mediaURL)) {
                        errors[index].mediaURL = _this.getErrorMessage('required');
                        isError = true;
                    }
                }
                if (_this.isEmpty(option.label, true)) {
                    errors[index].label = _this.getErrorMessage('required');
                    isError = true;
                }
                if (_this.isEmpty(option.value)) {
                    errors[index].value = _this.getErrorMessage('required');
                    isError = true;
                }
                else if (!Number.isFinite(+option.value)) {
                    errors[index].value = _this.getErrorMessage('invalid');
                    isError = true;
                }
                else if (valueNumber[option.value] > 1) {
                    errors[index].value = _this.getErrorMessage('duplicate');
                    isError = true;
                }
                if (isError) {
                    allError = true;
                    errors[index].isError = true;
                }
            });
            return __assign(__assign({}, errors), { isError: allError });
        };
        this.checkPopupcardWithLanguage = function (question, languages, questionTitles) {
            var _a;
            var cards = (question === null || question === void 0 ? void 0 : question.popupCards) || [];
            var errors = {};
            var cardType = ((_a = question === null || question === void 0 ? void 0 : question.popupSettings) === null || _a === void 0 ? void 0 : _a.popupCardTypes) ||
                (question === null || question === void 0 ? void 0 : question.selectedOptionType);
            var allError = false;
            cards.forEach(function (card, index) {
                var _a, _b;
                var isError = false;
                var textsError = {};
                errors[index] = {
                    questionTexts: {},
                    mediaURL: '',
                    title: ''
                };
                if (_this.isEmpty(card.title)) {
                    errors[index].title = _this.getErrorMessage('required');
                    isError = true;
                }
                if (card.title &&
                    !_this.validateQuestionTitle(card.title, __spreadArray(__spreadArray(__spreadArray([], questionTitles, true), [
                        (_b = (_a = question === null || question === void 0 ? void 0 : question.setupQuestion) === null || _a === void 0 ? void 0 : _a.title) === null || _b === void 0 ? void 0 : _b.toLowerCase()
                    ], false), cards
                        .filter(function (card, cIndex) { return cIndex !== index; })
                        .map(function (card) { var _a; return (_a = card === null || card === void 0 ? void 0 : card.title) === null || _a === void 0 ? void 0 : _a.toLowerCase(); }), true))) {
                    isError = true;
                    errors[index].title = _this.getErrorMessage('title_unique');
                }
                if (cardType !== types_1.OPTION_TYPES.TEXT_ONLY) {
                    if (_this.isEmpty(card.mediaURL)) {
                        errors[index].mediaURL = _this.getErrorMessage('required');
                        isError = true;
                    }
                    if (cardType === types_1.OPTION_TYPES.IMAGE_AND_TEXT) {
                        textsError = _this.validateMultimediaTexts(card.questionTexts || [], languages, false);
                        if (textsError.isError) {
                            isError = true;
                            errors[index].questionTexts = textsError;
                        }
                    }
                }
                else {
                    var checkQuestionTexts = _this.validateMultimediaTexts(card.questionTexts, languages);
                    if (checkQuestionTexts.isError) {
                        errors[index].questionTexts = checkQuestionTexts;
                        isError = true;
                    }
                }
                if (isError) {
                    allError = true;
                }
            });
            return { errorObject: errors, isError: allError };
        };
        this.validateAllConditions = function (type, conditions) {
            var errorObject = {
                isError: false
            };
            (conditions || []).forEach(function (condition, index) {
                var error = _this.validateSingleCondition(type, condition);
                if (error.isError) {
                    errorObject.isError = true;
                }
                errorObject[index] = error;
            });
            return errorObject;
        };
        /**
         * Validates that a @condition is valid, based on several criteria including:
         *  - all required fields are filled out
         *  - the selected comparison value is valid for the selected operator type
         */
        this.validateSingleCondition = function (type, condition) {
            var errorObject = { isError: false };
            (condition.rules || []).forEach(function (rule, index) {
                var _a, _b, _c, _d, _e;
                var error = {
                    isError: false
                };
                if (!rule.selectedOperator) {
                    error.isError = true;
                    error = __assign(__assign({}, error), { selectedOperator: _this.getErrorMessage('required') });
                }
                if (!rule.selectedReferenceQ) {
                    error.isError = true;
                    error = __assign(__assign({}, error), { selectedReferenceQ: _this.getErrorMessage('required') });
                }
                if (rule.selectedOperator) {
                    var type_1 = exports.AnswerType[rule.selectedOperator.value];
                    switch (type_1) {
                        case 'options':
                            if (!((_a = rule.compareOptions) === null || _a === void 0 ? void 0 : _a.length)) {
                                error.isError = true;
                                error = __assign(__assign({}, error), { value: _this.getErrorMessage('required') });
                            }
                            break;
                        case 'number':
                            if (!rule.compareNumber) {
                                error.isError = true;
                                error = __assign(__assign({}, error), { value: _this.getErrorMessage('required') });
                            }
                            break;
                        case 'string':
                            if (!((_b = rule.compareCustomValue) === null || _b === void 0 ? void 0 : _b.value)) {
                                error.isError = true;
                                error = __assign(__assign({}, error), { value: _this.getErrorMessage('required') });
                            }
                            break;
                        case 'boolean':
                            break;
                    }
                }
                if (((_c = rule.selectedReferenceQ) === null || _c === void 0 ? void 0 : _c.value) ===
                    constants_1.URL_METADATA_QUESTION_VALUE) {
                    if (!((_d = rule === null || rule === void 0 ? void 0 : rule.compareCustomValue) === null || _d === void 0 ? void 0 : _d.key) ||
                        /\s/.test((_e = rule === null || rule === void 0 ? void 0 : rule.compareCustomValue) === null || _e === void 0 ? void 0 : _e.key)) {
                        error.isError = true;
                        error = __assign(__assign({}, error), { key: _this.getErrorMessage('required') });
                    }
                }
                if (error.isError) {
                    errorObject.isError = true;
                }
                errorObject[index] = error;
            });
            if ((condition.rules || []).length === 0) {
                errorObject.isError = true;
                errorObject = __assign(__assign({}, errorObject), { isEmptyRule: _this.getErrorMessage('empty') });
            }
            if (type === 'postcondition') {
                if (!condition.destinationQ) {
                    errorObject.isError = true;
                    errorObject = __assign(__assign({}, errorObject), { destinationQ: _this.getErrorMessage('required') });
                }
            }
            return errorObject;
        };
        /**
         * Validator to check that any @buttons enabled for a @question have valid question texts
         * for all enabled project @languages.
         */
        this.checkButtonWithLanguage = function (question, keyName, languages, optionsSettings, buttonType) {
            var buttons = question[keyName] || [];
            var errors = { isError: false };
            //
            var optionType = buttonType; //"imageOnly"; // "textOnly" || "imageOnly" || "imageAndText";
            var isRichTextEditor = optionsSettings.isRichText;
            var allError = false;
            var valueNumber = {};
            buttons.forEach(function (button) {
                if (button.value in valueNumber) {
                    valueNumber[button.value]++;
                }
                else {
                    valueNumber[button.value] = 1;
                }
            });
            buttons.forEach(function (button, index) {
                var isError = false;
                var textsError = {};
                if (question.type === types_1.QTYPES.POPUP ||
                    (optionType !== types_1.OPTION_TYPES.IMAGE_ONLY &&
                        optionType !== types_1.OPTION_TYPES.CONDITION)) {
                    textsError = _this.validateMultimediaTexts(button.texts || [], languages, isRichTextEditor);
                    if (textsError.isError) {
                        isError = true;
                    }
                }
                errors[index] = {
                    texts: textsError || {},
                    mediaURL: '',
                    altTexts: {},
                    tags: '',
                    value: '',
                    label: '',
                    randomizeOption: ''
                };
                if (optionType === types_1.OPTION_TYPES.IMAGE_AND_TEXT ||
                    optionType === types_1.OPTION_TYPES.IMAGE_ONLY ||
                    question.type === types_1.QTYPES.POPUP) {
                    if (_this.isEmpty(button.mediaURL)) {
                        errors[index].mediaURL = _this.getErrorMessage('required');
                        isError = true;
                    }
                }
                if (_this.isEmpty(button.label)) {
                    errors[index] = __assign(__assign({}, errors[index]), { label: _this.getErrorMessage('required') });
                    isError = true;
                }
                if (_this.isEmpty(button.value)) {
                    errors[index] = __assign(__assign({}, errors[index]), { value: _this.getErrorMessage('required') });
                    isError = true;
                }
                else if (!Number.isFinite(+button.value)) {
                    errors[index] = __assign(__assign({}, errors[index]), { value: _this.getErrorMessage('invalid') });
                    isError = true;
                }
                else if (valueNumber[button.value] > 1) {
                    errors[index] = __assign(__assign({}, errors[index]), { value: _this.getErrorMessage('duplicate') });
                    isError = true;
                }
                if (isError) {
                    allError = true;
                }
            });
            return __assign(__assign({}, errors), { isError: allError });
        };
        /**
         * Validator to check that a "followUp" question is properly defined, if enabled.
         */
        this.checkFollowUpByEnabledButton = function (question, languages) {
            var errorObject = { isError: false };
            var buttonLabels = question.buttons.map(function (button) {
                return button.label.toUpperCase();
            }) || [];
            var keyNames = {
                LIKE: 'followUpTextsLike',
                DISLIKE: 'followUpTextsDislike',
                'NOT SURE': 'followUpTextsConfused'
            };
            buttonLabels.forEach(function (buttonLabel) {
                var checkFollowUp = _this.validateMultimediaTexts(question[keyNames[buttonLabel]], languages);
                if (checkFollowUp.isError) {
                    errorObject.isError = true;
                    errorObject[keyNames[buttonLabel]] = checkFollowUp;
                }
            });
            return errorObject;
        };
        this.type = type;
        this.QTYPES_VALIDATOR = (_a = {},
            _a[types_1.QTYPES.MULTIMEDIA] = this.validateMultimedia,
            _a[types_1.QTYPES.DEPARTING_MESSAGE] = this.validateDepartingMessage,
            _a[types_1.QTYPES.ICONS] = this.validateIconScale,
            _a[types_1.QTYPES.OPEN] = this.validateOpenEnd,
            _a[types_1.QTYPES.SINGLE_CHOICE] = this.validateOptions,
            _a[types_1.QTYPES.MULTIPLE_CHOICE] = this.validateOptions,
            _a[types_1.QTYPES.SCALE] = this.validateOptions,
            _a[types_1.QTYPES.RANK_ORDER] = this.validateOptions,
            _a[types_1.QTYPES.AD_BUILDER] = this.validateOptions,
            _a[types_1.QTYPES.POPUP] = this.validatePopup,
            _a[types_1.QTYPES.GROUP] = this.validateGroup,
            _a[types_1.QTYPES.TRADE_OFF] = this.validateTradeOff,
            _a[types_1.QTYPES.VIDEO_ANNOTATION] = this.validateVideoAnnotation,
            _a[types_1.QTYPES.HOTSPOT] = this.validateHotspot,
            _a[types_1.QTYPES.TREEMAN] = this.validateHotspot,
            _a[types_1.QTYPES.TEXT_HIGHLIGHTER] = this.validateTextHighlighter,
            _a[types_1.QTYPES.GUIDED_FANTASY] = this.validateGuidedFantasy,
            _a[types_1.QTYPES.VIRTUAL] = this.validateVirtualQuestion,
            _a[types_1.QTYPES.VECTOR_MAP] = this.skipQuestionValidation,
            _a[types_1.QTYPES.RAPID_CHOICE] = this.validateOptions,
            _a[types_1.QTYPES.NPS] = this.validateNPSQuestion,
            _a[types_1.QTYPES.NUMERIC] = this.validateNumericQuestion,
            _a);
    }
    ValidationService.prototype.getErrorMessage = function (keyName) {
        return this.type === 'type'
            ? this.ERROR_TYPES[keyName]
            : this.ERROR_MESSAGES[keyName];
    };
    ValidationService.prototype.validateByQuestionType = function (question, languages, questionTitles) {
        var _a;
        if (questionTitles === void 0) { questionTitles = []; }
        var isError = false, errorObject = {};
        var title = question.title, questionTexts = question.questionTexts, type = question.type, showNotApplicableOption = question.showNotApplicableOption, notApplicableTexts = question.notApplicableTexts, showContinueButton = question.showContinueButton, continueTexts = question.continueTexts, optionSettings = question.optionSettings, isAudience = question.isAudience, builtInID = question.builtInID, piping = question.piping, pipingQuestions = question.pipingQuestions;
        var disableValidation = isAudience && !!builtInID;
        if (disableValidation) {
            return { isError: isError, errorObject: errorObject };
        }
        try {
            /** BEGIN COMMON FIELDS  */
            if (this.isEmpty(title) &&
                ![types_1.QTYPES.POPUP].includes(type)) {
                isError = true;
                errorObject = __assign(__assign({}, errorObject), { title: this.getErrorMessage('required') });
            }
            if (title &&
                !this.validateQuestionTitle(title, questionTitles) &&
                ![types_1.QTYPES.POPUP].includes(type)) {
                isError = true;
                errorObject = __assign(__assign({}, errorObject), { title: this.getErrorMessage('title_unique') });
            }
            var validateQuestionTexts = this.validateMultimediaTexts(questionTexts, languages, [
                types_1.QTYPES.GROUP,
                types_1.QTYPES.POPUP,
                types_1.QTYPES.GUIDED_FANTASY,
                types_1.QTYPES.VIRTUAL
            ].includes(type));
            if (validateQuestionTexts.isError) {
                isError = true;
                errorObject = __assign(__assign({}, errorObject), { questionTexts: validateQuestionTexts });
            }
            if (showNotApplicableOption) {
                var checkNotApplicableTexts = this.validateMultimediaTexts(notApplicableTexts, languages, [types_1.QTYPES.VIRTUAL].includes(question.type));
                if (checkNotApplicableTexts.isError) {
                    isError = true;
                    errorObject = __assign(__assign({}, errorObject), { notApplicableTexts: checkNotApplicableTexts });
                }
            }
            if (showContinueButton) {
                var checkContinueTexts = this.validateMultimediaTexts(continueTexts, languages);
                if (checkContinueTexts.isError) {
                    isError = true;
                    errorObject = __assign(__assign({}, errorObject), { continueTexts: checkContinueTexts });
                }
            }
            if (piping && !(pipingQuestions === null || pipingQuestions === void 0 ? void 0 : pipingQuestions.length)) {
                isError = true;
                errorObject = __assign(__assign({}, errorObject), { pipingQuestions: this.getErrorMessage('required') });
            }
            /** END COMMON FIELDS */
            /** BEGIN BY QUESTION TYPE */
            if (!(type in this.QTYPES_VALIDATOR)) {
                throw new Error("Validation Not Supported: ".concat(type));
            }
            var questionValidator = (_a = this.QTYPES_VALIDATOR) === null || _a === void 0 ? void 0 : _a[type](question, isError, errorObject, languages, questionTitles);
            isError = questionValidator.isError;
            errorObject = questionValidator.errorObject;
            /** END QUESTION TYPE */
            return { isError: isError, errorObject: errorObject };
        }
        catch (err) {
            console.error('Validation Error: ', err);
        }
        return { isError: isError, errorObject: errorObject };
    };
    return ValidationService;
}());
exports.default = ValidationService;
//# sourceMappingURL=ValidationService.js.map